/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import {
  EuiListGroup,
  EuiListGroupItem,
  EuiPopover,
} from "@inscopix/ideas-eui";
import { CustomCellEditorProps } from "ag-grid-react";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";
import { useState } from "react";
import { TOOL_EDITOR_PARAMETER_PROPERTIES } from "../ParametersEditor";
import { ParamsEditorRowDatum } from "components/ToolEditor/ToolEditor.types";

const styles = {
  popover: css`
    & {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
    }
  `,
  panel: css`
    max-height: max(200px, 50vh);
    overflow-y: scroll;
  `,
};

export const CellEditorType = ({
  data,
  stopEditing,
}: CustomCellEditorProps<ParamsEditorRowDatum>) => {
  const [value, setValue] = useState(data.type.param_type);
  const changeSpecParamType = useToolEditorContext(
    (s) => s.changeSpecParamType,
  );

  return (
    <EuiPopover
      anchorPosition="downCenter"
      button={
        <span
          css={css`
            overflow: hidden;
            text-overflow: ellipsis;
          `}
        >
          {TOOL_EDITOR_PARAMETER_PROPERTIES[value].friendlyName}
        </span>
      }
      isOpen
      panelPaddingSize="none"
      css={styles.popover}
      closePopover={stopEditing}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          stopEditing(true);
        }
      }}
      display="block"
      repositionOnScroll={true}
      panelProps={{ paddingSize: "none" }}
    >
      <EuiListGroup css={styles.panel} maxWidth="100%">
        {(
          [
            "ToolPathParam",
            "ToolIntRangeParam",
            "ToolFloatRangeParam",
            "ToolStringParam",
            "ToolBooleanParam",
            "ToolChoiceParam",
          ] as const
        ).map((option) => (
          <EuiListGroupItem
            id={option.toString()}
            key={option.toString()}
            iconType={value === option ? "check" : "empty"}
            label={
              <span
                css={css`
                  overflow: hidden;
                  text-overflow: ellipsis;
                `}
              >
                {TOOL_EDITOR_PARAMETER_PROPERTIES[option].friendlyName}
              </span>
            }
            onClick={() => {
              if (value !== option) {
                changeSpecParamType(data.key, option);
                setValue(option);
                stopEditing();
              }
            }}
          />
        ))}
      </EuiListGroup>
    </EuiPopover>
  );
};
